import { UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { styles as SharedStyles } from '../../auth/SignupFormsStyles';
import { createDemoStudioBookingOpened } from '../../Bookings/actions';
import { IAppStore } from '../../HomeWorkouts';
import Theme from '../../theme';
import { UserDataConsumer } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import { CannotLaunchDemoBookingScreen } from '../reducers';
import { createDemoBookingScreenDataSelector } from '../selectors';
import CannotCreateDemoBooking from './CannotCreateDemoBooking';

interface ICreateDemoBookingScreenData {
  createDemoBookingScreenError: null | Error;
  loadingCreateDemoData: boolean;
  cannotLaunchDemoBookingScreen: CannotLaunchDemoBookingScreen;
  shouldNavigateToInstallAppScreen: boolean;
}

interface IProps {
  user: { userProfile: UserProfile };
  screenData: ICreateDemoBookingScreenData;
  createDemoScreenMounted: () => void;
  t: (key: string, options?: any) => string;
  navigation: {
    navigate: (route: string) => void;
  };
}

class CreateDemoStudioBooking extends PureComponent<IProps> {
  public componentDidMount() {
    this.props.createDemoScreenMounted();
  }

  public render() {
    const {
      screenData: {
        loadingCreateDemoData: loading,
        cannotLaunchDemoBookingScreen,
        shouldNavigateToInstallAppScreen,
      },
      t,
      user: { userProfile },
      navigation,
    } = this.props;

    if (loading) {
      return (
        <View style={[styles.container, { justifyContent: 'center' }]}>
          <ActivityIndicator
            size={'small'}
            color={Theme.PRIMARY}
            animating
          />
        </View>
      );
    }

    if (shouldNavigateToInstallAppScreen) {
      navigation.navigate('HomeInstallAppScreen');
    }

    return (
      <View style={[
        SharedStyles.container,
        styles.container,
        !cannotLaunchDemoBookingScreen && { height: 0, paddingBottom: 0 },
      ]}>
        {cannotLaunchDemoBookingScreen &&
          <CannotCreateDemoBooking
            t={t}
            userProfile={userProfile}
            cannotLaunchDemoBookingScreen={cannotLaunchDemoBookingScreen}
          />
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: '100%',
    paddingBottom: defaultScale(15),
  },
});

const mapStateToProps = (state: IAppStore) => ({
  screenData: createDemoBookingScreenDataSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const { user: { userProfile }, navigation } = ownProps;
  return {
    createDemoScreenMounted: () => dispatch(createDemoStudioBookingOpened(userProfile, navigation.navigate)),
  };
};

export default UserDataConsumer(
  translate(['auth'], { wait: true })(
    connect(mapStateToProps, mapDispatchToProps)
    (CreateDemoStudioBooking)));
